import React, { useEffect, useRef } from 'react';
var elementsWithFocus = 'a[href],button,input,textarea,select,details,[tabindex]:not([tabindex="-1"])';

/* toDo: починить! сейчас исправлено некорректно, не будет работать ни с одной модалкой,
ни с несколькими модалками. Старый вариант работы с одной модалкой вернуть нельзя, так как из-за
него ломается дэйт пикер в модалке */
export var useFocusTrap = function useFocusTrap(_ref) {
  var isActive = _ref.isActive,
    containerRef = _ref.containerRef;
  var focusCatcherRef = useRef(null);
  useEffect(function () {
    /** возможен кейс, когда открывается модалка поверх модалки (например в дэйт пикере),
     * и нам нужно, чтобы работа с фокусом шла бы только в последнем самом верхнем открытом портале модалки
     * если же модалка одна, захват фокуса будет продолжать на ней работать как прежде */
    var allPortals = document.querySelectorAll('.portal-container');
    var theNewestPortal = allPortals[allPortals.length - 1];
    var handleGlobalFocus = function handleGlobalFocus(event) {
      var isEventInNewestPortal = theNewestPortal.contains(event.target);
      if (isEventInNewestPortal) {
        var _containerRef$current;
        var focusableElements = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelectorAll(elementsWithFocus)) || [];
        var isFocusOnLastItem = event.target === focusableElements[focusableElements.length - 1];
        var isFocusInModal = !![].find.call(focusableElements, function (item) {
          return item === event.target;
        });
        if (isFocusOnLastItem || !isFocusInModal) {
          focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements[0].focus();
        }
      }
    };
    if (isActive) {
      document.addEventListener('focus', handleGlobalFocus, true);
    }
    return function () {
      return document.removeEventListener('focus', handleGlobalFocus, true);
    };
  }, [containerRef, isActive]);
  return /*#__PURE__*/React.createElement("button", {
    "aria-hidden": true,
    ref: focusCatcherRef,
    style: {
      opacity: 0,
      position: 'absolute',
      top: '0'
    },
    type: "button"
  });
};